import bubblechatLocaleEn from './locales/bubblechat/locale-en.json';
import bubblechatLocaleKo from './locales/bubblechat/locale-ko.json';
import bubblechatLocaleTh from './locales/bubblechat/locale-th.json';
import bubblechatLocaleZh from './locales/bubblechat/locale-zh.json';
import tingleLocaleEn from './locales/tingle/locale-en.json';
import tingleLocaleKo from './locales/tingle/locale-ko.json';
import tingleLocaleTh from './locales/tingle/locale-th.json';
import tingleLocaleZh from './locales/tingle/locale-zh.json';

export const languages = ['en', 'ko', 'th', 'zh'] as const;

export type Languages = (typeof languages)[number];

export const SERVICE_RESOURCES = {
  bubblechat: {
    en: { translation: bubblechatLocaleEn },
    ko: { translation: bubblechatLocaleKo },
    th: { translation: bubblechatLocaleTh },
    // TODO: 버블챗은 대만어 번역 아직 적용하지 않음
    zh: { translation: bubblechatLocaleKo },
  },
  tingle: {
    en: { translation: tingleLocaleEn },
    ko: { translation: tingleLocaleKo },
    th: { translation: tingleLocaleTh },
    zh: { translation: tingleLocaleZh },
  },
};

const services = ['bubblechat', 'tingle'] as const;
export type ServiceName = (typeof services)[number];

export const serviceName: ServiceName = (import.meta.env.VITE_APP_SERVICE_NAME as ServiceName) || 'bubblechat';

export const resources = SERVICE_RESOURCES[serviceName] || SERVICE_RESOURCES.bubblechat;
